module.exports = __webpack_public_path__ + "static/media/ios-move.0241f01b.svg";